import { NEXT_PUBLIC_DISCOVER_DEV_MENU_ENABLED } from '@/lib/env';
import { useStoreState } from '@discover-data/stores/restaurant/hooks';
import DevMenuRoot, { type DevMenuRootProps } from './root';
import State from './state';
import AuthTests from './authTests';

export type RestaurantStoreDevMenuProps = Omit<DevMenuRootProps, 'title'>;

export default function RestaurantStoreDevMenu({ ...props }: RestaurantStoreDevMenuProps) {
  const name = useStoreState((state) => state.name);
  if (!NEXT_PUBLIC_DISCOVER_DEV_MENU_ENABLED) {
    return null;
  }

  return (
    <DevMenuRoot {...props} title={name}>
      <h2 className="m-0 my-1 text-md">{name}</h2>
      <State />
      <AuthTests />
    </DevMenuRoot>
  );
}
